import { IItems } from '../../timeline/store/timeline.types'

export const sortEkgTimelineItems = (
  initialTimelineItems: IItems,
  vitalsTimelineItems: IItems,
  procedureTimelineItems: IItems
): IItems => {
  const timelineItemsPlusVitals = [...initialTimelineItems, ...vitalsTimelineItems]
  timelineItemsPlusVitals.sort((a, b) => {
    return +new Date(a.date) - +new Date(b.date)
  })

  const timelineItems: IItems = []
  timelineItemsPlusVitals.forEach((timelineItem) => {
    timelineItems.push(timelineItem)

    if (timelineItem.clientEventId && timelineItem.vsAction) {
      const procedureForItem = procedureTimelineItems.find(
        (procedureItem) => procedureItem.key === timelineItem.clientEventId
      )

      if (procedureForItem) {
        timelineItems.push(procedureForItem)
      }
    }
  })

  return timelineItems
}
